import { CSSObject } from "@emotion/react";

export const tableStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>;
} => ({
  tableWrapper: {
    width: "100%",
    whiteSpace: "nowrap",
    WebkitOverflowScrolling: "touch", // smooth swipe on iOS
    scrollbarWidth: "thin",
    overflowX: "auto",
    overflowY: "auto",
    minHeight: "30vh",
    maxHeight: "80vh",
    position: "relative", // required for sticky positioning
  },
  container: {
    background: "white",
    width: "100%",
    borderWidth: 1,
    borderColor: "red",
  },
  filterBar: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
    height: 70,
    alignItems: "center",
    gap: 20,
  },
  searchInput: {
    fontSize: 14,
    borderWidth: 1,
    borderRadius: 24,
    padding: "10px 15px",
    height: 20,
    border: "1px solid #D9D9D9",
    width: "70%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    borderBottom: "1px solid black",
    background: "#FFFFFF",
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 0,
  },

  tableHeaderCell: {
    // background: "white",
    fontSize: 14,
    borderBottom: "1px solid black",
    background: "#FFFFFF",
    padding: 10,
    position: "sticky",
    top: 0,
    zIndex: 3,
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    background: "#FFFFFF",
  },
  headerLabel: {
    marginRight: 25,
  },
  tableRow: {
    border: "1px solid #ddd",
    cursor: "pointer",
    // width: "15%",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableCell: {
    fontSize: 14,
    fontFamily: "Gilroy-Regular",
    textAlign: "left",
    padding: "10px",
    // width: "15%",
  },
  numberCell: {
    textAlign: "center",
  },
  noResults: {
    textAlign: "center",
  },
  statusCell: {
    // minWidth: "15%",
    fontWeight: "bold",
    color: "#30916B",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  statusBadge: {
    background: "#EAFFE3",
    borderRadius: "24px",
    fontSize: 14,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "center",
    display: "inline-block",
    minWidth: 100,

  },
  openStatusBadge: {
    background: "#FFF1E3",
    color: "#913035",
    borderRadius: "24px",
    fontSize: 14,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
  },
  progressStatusBadge: {
    background: "#FFFCC2",
    color: "#9F6820",
    borderRadius: "24px",
    fontSize: 14,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
  },
  resolvedStatusBadge: {
    background: "#EAFFE3",
    color: "#30916B",
    borderRadius: "24px",
    fontSize: 14,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
  },

  inactiveStatusBadge: {
    background: "#FFF1E3",
    color: "#913035",
    borderRadius: "24px",
    fontSize: 14,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "center",
    display: "inline-block",
    minWidth: 100,

  },
  emailCell: {
    paddingRight: 15,
  },
  actionCell: {
    padding: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },

  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    gap: "10px",
  },
  paginationButton: {
    padding: "8px 12px",
    border: "0px solid #D9D9D9",
    borderRadius: "4px",
    backgroundColor: "#fff",
    cursor: "pointer",
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
    "&:hover:not(:disabled)": {
      backgroundColor: "#f5f5f5",
    },
  },

  pageInfo: {
    // marginLeft: "20px",
    fontSize: "14px",
    color: "#666",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
});
